import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import {
  TipoFuncionalidade,
  TipoValidacaoCadastral, ValidacaoCadastroModalComponent, ValidacaoCadastroModalData
} from 'src/app/shared/components/validacao-cadastro-modal/validacao-cadastro-modal.component';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { ModalWrapperData } from 'src/app/shared/models/modal-wrapper-data.model';
import PerfilCliente from 'src/app/shared/models/perfil-cliente.model';
import { BaseModalService } from 'src/app/shared/services/base-modal.service';
import { PasswordRecoveryService } from 'src/app/shared/services/password-recovery.service';
import { PerfilService } from '../perfil.service';

export enum TipoAlteracaoPerfilEnum {
  SENHA = 'senha',
  EMAIL = 'email',
  TELEFONE = 'telefone'
}

@Component({
  selector: 'app-selecao-canal-validacao-page',
  templateUrl: './selecao-canal-validacao-page.component.html',
  styleUrls: ['./selecao-canal-validacao-page.component.scss']
})
export class SelecaoCanalValidacaoPageComponent implements OnInit {

  subscriptions = new Subscription();
  tipoAlteracao: TipoAlteracaoPerfilEnum;
  TipoAlteracaoPerfilEnum = TipoAlteracaoPerfilEnum;
  clientePerfil = new PerfilCliente();
  modalValidacaoRef: MatDialogRef<any>;
  TipoValidacaoCadastral = TipoValidacaoCadastral;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  formTitle = {
    [TipoAlteracaoPerfilEnum.EMAIL]: 'Alterar e-mail',
    [TipoAlteracaoPerfilEnum.SENHA]: 'Alterar Senha',
    [TipoAlteracaoPerfilEnum.TELEFONE]: 'Alterar celular',
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private perfilService: PerfilService,
    private loaderService: LoaderService,
    private baseModalService: BaseModalService,
    private passwordRecoveryService: PasswordRecoveryService,
    public breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(this.setRouterParameterSubscribe());
    this.buscarClientePerfil();
    this.passwordRecoveryService.clearStorageData();
  }

  setRouterParameterSubscribe() {
    return this.route.params.subscribe(({ tipoAlteracao }) => {
      const isParamValid = Object.values(TipoAlteracaoPerfilEnum).includes(tipoAlteracao);
      if (!isParamValid) {
        this.location.back();
      }

      this.tipoAlteracao = tipoAlteracao;
    });
  }

  async buscarClientePerfil() {
    try {
      this.loaderService.start();
      const clientePerfil = await this.perfilService.getPerfil();
      if (clientePerfil) {
        this.clientePerfil = clientePerfil;
        if (this.clientePerfil.celular) {
          this.clientePerfil.celular = this.clientePerfil.celular.substring(3);
        }
      }
    } catch (response) {
    } finally {
      this.loaderService.stop();
    }
  }

  async selectVerificationMethod(type: TipoValidacaoCadastral) {
    const selectedMethodData = type === TipoValidacaoCadastral.PHONE ? this.clientePerfil.celular : this.clientePerfil.email;

    this.passwordRecoveryService.setSelectedVerificationMethodInfo({
      selectedMethod: type,
      selectedMethodData,
      methodsData: {
        email: this.clientePerfil.email,
        phone: this.clientePerfil.celular,
      }
    });

    this.router.navigate([`/portal/perfil/alterar/${this.tipoAlteracao.toLowerCase()}/confirmar-token`]);
  }

  goToProfilePage() {
    this.router.navigate(['/portal/perfil'])
  }

  goToAccountConfirmationPage() {
    this.router.navigate([`portal/perfil/alterar/${this.tipoAlteracao.toLowerCase()}/confirmar-conta`])
  }

  async showUpdateEmailModal() {
    const data: ModalWrapperData<ValidacaoCadastroModalData> = {
      title: this.clientePerfil.email ? 'Alterar e-mail' : 'Adicionar e-mail',
      component: ValidacaoCadastroModalComponent,
      config: { disableClose: true, autoFocus: true, width: '100%', maxWidth: '643px' },
      data: {
        tipo: TipoValidacaoCadastral.EMAIL,
        funcionalidade: this.clientePerfil.email ? TipoFuncionalidade.ALTERACAO : TipoFuncionalidade.CADASTRO,
        initialValue: this.clientePerfil.email,
      }
    };

    this.modalValidacaoRef = this.baseModalService.showModal(data);

    const modalResponse: { valido: boolean, showConfirmationModal?: boolean } = await this.modalValidacaoRef.afterClosed().toPromise();

    if (modalResponse.valido) {
      this.buscarClientePerfil();
    }
  }
}
